import React from "react";
import PropTypes from "prop-types";
import ScrollableBox from "core-web/components/ScrollableBox";
import styled from "theme/libs/styled";
import CategoryCard from "theme/components/CategoryCard";

const Wrapper = styled("div")`
    padding-block: 24px;
`;

const MaskedScrollableBox = styled(ScrollableBox)`
    --slider-padding: 20px;

    ${({ theme }) => theme.above.tabletLg} {
        --slider-padding: 48px;
    }

    display: flex;
    gap: 8px;
    padding-inline: var(--slider-padding);
    mask-image: linear-gradient(
        90deg,
        transparent,
        #fff var(--slider-padding),
        #fff calc(100% - var(--slider-padding)),
        transparent 100%
    );
`;

const CategorySlider = ({ categories, withImages, parentTitle, imageLoading, textStyles, ...rest }) => {
    return (
        <Wrapper {...rest}>
            <MaskedScrollableBox as="ul" scrollDirection="horizontal">
                {(categories || []).map(
                    ({ callback, url, permalink, title, image, category_img: categoryImage, selected }, index) => (
                        <li key={title || `category-${index}`}>
                            <CategoryCard
                                paddingInline={
                                    image || categoryImage
                                        ? "0 calc(var(--slider-padding) / 3)"
                                        : "calc(var(--slider-padding) / 3)"
                                }
                                callback={callback}
                                imageLoading={index > 3 ? "lazy" : imageLoading}
                                url={url || permalink}
                                title={title}
                                isCurrent={title === parentTitle || selected}
                                image={withImages ? image || categoryImage : null}
                                textStyles={textStyles}
                            />
                        </li>
                    ),
                )}
            </MaskedScrollableBox>
        </Wrapper>
    );
};

CategorySlider.propTypes = {
    categories: PropTypes.array,
    imageLoading: PropTypes.string,
    parentTitle: PropTypes.string,
    slidesPerView: PropTypes.number,
    textStyles: PropTypes.oneOf([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
    withImages: PropTypes.bool,
    gridOnMobile: PropTypes.bool,
};

CategorySlider.defaultProps = {
    categories: [],
    imageLoading: "eager",
    parentTitle: "",
    slidesPerView: 4.5,
    textStyles: "Myriad Pro/16-100",
    withImages: true,
    gridOnMobile: false,
};

export default CategorySlider;
